export default {
  id: "weblinkSales19",
  name: "",
  description: "",
  report: {
    name: "Weblink Sales (19)",
    chartType: "COLUMN",
    template: "custom",
    config: {
      dataSet: "Sale",
      dataType: "time_series",
      dimensions: [],
      measures: ["Sale.total_revenue"],
      sort: {
        direction: null,
        by: null,
      },
      timeDimension: "Sale.sale_time",
      timeGranularity: "day",
      filters: [
        {
          member: "Sale.weblink_group",
          operator: "equals",
          values: ["19"],
        },
      ],
      compare: true,
      limit: "999",
      rowTotals: false,
      points: false,
      colorTheme: "default",
    },
  },
};
